import { Message } from '@assets/svg';
import { Button, Flex, Text } from '@components';
import { useTheme, Box } from '@mui/material';
import { useMediaQueries } from '@utils/mediaQueries/mediaQueries';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

const RecoveryEmail: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { sm: isMobile } = useMediaQueries();

  const onSubmit = () => {
    navigate(-2);
  };

  return (
    <Flex flex={1} justifyContent='center' flexDirection='column'>
      <Box mb={10}>
        <Message />
      </Box>
      <Text variant='h4' fontWeight='fontWeightBold'>
        <FormattedMessage id='recoveryEmail.recoveryEmailSent' />
      </Text>
      <Text
        variant='h5'
        fontWeight='fontWeightRegular'
        style={{
          color: theme.palette.grey.A100,
          marginTop: theme.spacing(3),
        }}
      >
        <FormattedMessage
          values={{
            br: <br />,
          }}
          id='recoveryEmail.recoveryEmailMessage'
        />
      </Text>
      <Box mt={16}>
        <Button
          fullWidth={isMobile}
          variant='primary'
          data-testid='back-to-login'
          size='large'
          type='submit'
          color='primary'
          onClick={onSubmit}
        >
          <FormattedMessage id='recoveryEmail.backToLogin' />
        </Button>
      </Box>
    </Flex>
  );
};

export default RecoveryEmail;
